$('.form-group.textarea-field').each(function() {

	let textarea = $(this).find('textarea');
	let label = $(this).find('label');

	if(typeof textarea.attr('maxlength') !== 'undefined') {
		
		let counter = 
		'<span class="textarea-counter">' +
			'<span class="textarea-counter__current">' + 
				textarea.val().length + 
			'</span>' +
			' / ' +
			'<span class="textarea-counter__max">' +
				textarea.attr('maxlength') +
			'</span>'
		'</span>';
		label.append($(counter));

	}

});

$('textarea').on('keyup', function() {
	
	if(typeof $(this).attr('maxlength') === 'undefined') {
		return;
	}

	let textarea_container = $(this).parents('.form-group.textarea-field');

	let characterCount = $(this).val().length,
		current = textarea_container.find('.textarea-counter__current');

	current.text(characterCount);

});

if($('.tx-sf-event-mgt .error').length > 0) {

	$('html, body').animate({
		scrollTop: $('.error:visible:first').offset().top - 333
	}, 250);

}